import { WRONG_PASSWORD, WRONG_PASSWORD_IN } from "app/configs/withdrawForm.config";
import { ApiRequestConfig } from "app/interfaces/api-request/api.interface";
import endpoints from "constants/endpoints";
import { call, put, takeLatest } from "redux-saga/effects";
import { setGlobalLoaderAction } from "../actions/CommonAction";
import {
    failedWithdrawAction, ISubmitWithdrawPayload, resetWithdrawStateAction,
    submitWithdrawAction, successWithdrawAction, getWithdrawFeeAction, GetWithdrawFeePayload, setWithdrawFee
} from '../actions/WithdrawAction';
import apiRequest from "../api/api.request";

function* submitWithdraw({
    payload
}: {
    payload: ISubmitWithdrawPayload;
}): Generator {
    yield put(setGlobalLoaderAction(true));
    const auth = JSON.parse(localStorage.getItem('user') as string);
    const body = {
        bankCode: payload.bankCode,
        accountName: payload.accountName,
        accountNumber: payload.accountNumber,
        password: payload.password,
        reason: payload.reason,
        amount: payload.amount,
        methodPayment: payload.methodPayment
    };
    const config: ApiRequestConfig = {
        path: endpoints.api.WITHDRAW,
        method: 'PUT',
        headers: {
            Authorization: `Bearer ${auth.token}`,
        },
        query: null,
        body,
        timeout: 0,
    };

    try {
        yield call(apiRequest, config);
        // const { data } = res as any;
        yield (put(successWithdrawAction('success')));
    } catch (err) {
        const message: string = err as string;
        if (err === WRONG_PASSWORD) {
            yield put(failedWithdrawAction({ error: WRONG_PASSWORD_IN, message: '' }));
        } else {
            yield put(failedWithdrawAction({ error: '', message }));
        }
    }
}

function resetWithdraw({ payload }: { payload: boolean }): boolean {
    try {
        return payload;
    } catch (err) {
        return payload;
    }
}

function* getWithdrawFee({
    payload
}: {
    payload: GetWithdrawFeePayload;
}): Generator {
    yield put(setGlobalLoaderAction(true));
    const auth = JSON.parse(localStorage.getItem('user') as string);
    const body = {
        bank_code: payload.bankCode,
        amount: payload.amount,
        payment_method: payload.payment_method
    };
    const config: ApiRequestConfig = {
        path: endpoints.api.WITHDRAW_FEE,
        method: 'POST',
        headers: {
            Authorization: `Bearer ${auth.token}`,
        },
        query: null,
        body,
        timeout: 0,
    };

    try {
        const res = yield call(apiRequest, config);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { data } = res as any;
        yield put(setWithdrawFee(data));
    } catch (err) {
        // return payload;
    }
}

export default function* WithdrawSaga(): Generator {
    yield takeLatest(submitWithdrawAction, submitWithdraw);
    yield takeLatest(resetWithdrawStateAction, resetWithdraw);
    yield takeLatest(getWithdrawFeeAction, getWithdrawFee);
}
